import merge from 'lodash/merge'
import applogger from '@applogger'
import EcommerceUI from '@aspedia/vuejs-ecommerce-ui'
import EcommerceProductCatalog from 'dev/vuejs-ecommerce-product-catalog'
import ContentListRegistry from 'dev/content-creator/content-list-registry'

import IntegrapayCreditCards from '@aspedia/integrapay_credit_cards'
// import IntegrapayCreditCards from '../../vuejs-dev/integrapay_credit_cards/src/library.js'

import StripeConnectPayments from '@aspedia/vue-stripe-connect-payments'
// import StripeConnectPayments from '../../vuejs-dev/stripe-payments/src/index.js'

import SquarePayments from '@aspedia/square-payments'
import '@aspedia/square-payments/dist/square-payments.css'
// import '@aspedia/square-payments/dist/square-payments-pos-override.css'
// import SquarePayments from '../../vuejs-dev/square-payments/src/index.js'

export default function(app, Vue, appOptions) {
  if (app.registry.getFeature('ecommerce')) {
    if (!this.ecommerceOptions.endpointURL) {
      const datastore = app.registry.getServiceEndpoint('datastore')
      if (!datastore) {
        this.ecommerceOptions.endpointURL = this.location.origin + '/vuejs/ecommerce'
        const matches = this.location.host.match(/(crm|www|portal|directory|conference)\.(.*)/)
        if (matches) {
          this.ecommerceOptions.endpointURL = this.location.scheme + '//www.' + matches[2] + '/vuejs/ecommerce'
        }
      }
      else {
        this.ecommerceOptions.endpointURL = `${datastore}/vuejs/ecommerce`
      }
    }

    const options = merge({
      links: {
        checkout: '/checkout',
        cartView: '/cart/view',
        continueShopping: app.registry.getModuleSetting('ecommerce', 'continueShoppingLink', '/wines')
      },
      useCookieCredentials: false,
      loginComponent: 'login-subform',
      disableCheckoutPickup: app.registry.getModuleSetting('ecommerce', 'disableCheckoutPickup', false),
      allowRegisterOnCheckout: app.registry.getModuleSetting('ecommerce', 'allowRegisterOnCheckout', true),
      allowAnonCheckout: app.registry.getModuleSetting('ecommerce', 'allowAnonCheckout', true),
      address_module: app.registry.getModuleSetting('ecommerce', 'address_module', '001'),
      googleAddressesAPIKey: app.registry.getModuleSetting('ecommerce', 'googleAddressesAPIKey', false)
    }, this.ecommerceOptions)

    app.addPlugin(EcommerceUI, {
      ...options,
      callback: _ => {
        return app.addPreloadItem(({ store }) => {
          return store.dispatch('ecommerce/init', { wait: true })
            .then(_ => applogger.log('Ecommerce Init complete'))
        })
      }

    })
    app.addPlugin(EcommerceProductCatalog)

    app.addRoutes([
      {
        path: '/cart/view',
        component: EcommerceUI.CartView,
        name: 'View Cart',
        meta: { requiresAuth: 'cache' }
      },
      {
        path: '/checkout',
        component: EcommerceUI.Checkout,
        name: 'Checkout',
        meta: { requiresAuth: 'cache' }
      }
    ])

    app.addRoutes([
      {
        path: '/payment/:txnid',
        component: EcommerceUI.PaymentMethodSelect,
        name: 'Select Payment Method',
        meta: { requiresAuth: 'cache' }
      }
    ])

    // COD Payments
    if ((process.env.SERVER_BUILD !== 'ssr')) {
      app.addPreloadItem(({ store }) => {
        store.commit('ecommerce/REGISTER_PAYMENT_METHOD_ACTIVE', { method: 'cod', handler: true })
      })
      app.addRoutes([
        {
          path: '/payment/cod/:txnid',
          component: EcommerceUI.ECPaymenCODForm,
          name: 'COD Payment',
          meta: { requiresAuth: 'cache' }
        }
      ])
    }

    // Integray Pay
    if (app.registry.getFeature('integrapay') && (process.env.SERVER_BUILD !== 'ssr')) {
      app.addPlugin(IntegrapayCreditCards, {
        callback: ({ store }) => {
          store.commit('ecommerce/REGISTER_PAYMENT_METHOD_ACTIVE', { method: 'integrapay', handler: true })
        }
      })
      app.addRoutes([
        {
          path: '/payment/integrapay/:txnid',
          component: EcommerceUI.IntegrapayPayment,
          name: 'Integrapay Payment',
          meta: { requiresAuth: 'cache' }
        },
        {
          path: '/complete/:method/:txnid/:rcptid',
          component: EcommerceUI.ECPaymentSummary,
          name: 'Payment Summary',
          meta: { requiresAuth: 'cache' }
        }
      ])
    }

    // Stripe Connect Payments
    if (app.registry.getFeature('stripe-connect-payments') && (process.env.SERVER_BUILD !== 'ssr')) {
      app.addPlugin(StripeConnectPayments, {
        callback: ({ store }) => {
          store.dispatch('ecommerce/onInit', ({ store, config }) => {
            try {
              if (Object.prototype.hasOwnProperty.call(config, 'stripe_connect_payments')) {
                store.commit('stripe/SET_MODE', config.stripe_connect_payments.testmode ? 'development' : 'production')
                store.commit('stripe/SET_ENDPOINT', store.getters.getServiceEndpoint('payments'))
                store.commit('ecommerce/REGISTER_PAYMENT_METHOD_ACTIVE', { method: 'stripe_connect_payments', handler: store.getters['stripe/active'] })

                // We add this promise to the list of promisses required for Payment method to be used so that we can wait if required for them to complete.
                const p = store.dispatch('stripe/getIsConnected')
                  .finally(_ => {
                    store.commit('ecommerce/PAYMENT_METHOD_PROMISES', { stripe_connect_payments: null })
                  })
                store.commit('ecommerce/PAYMENT_METHOD_PROMISES', { stripe_connect_payments: p })
              }
              else {
                applogger.error('Disabling stripe payments as it is not enabled in the backend.')
                store.commit('ecommerce/REGISTER_PAYMENT_METHOD_ACTIVE', { method: 'stripe_connect_payments', handler: false })
              }
            }
            catch (err) {
              applogger.error(`Disabling stripe payments due to configuration error: ${err.message}`)
            }
          })
        }
      })
      app.addRoutes([
        {
          path: '/admin/ecommerce/stripe',
          component: EcommerceUI.StripeConnectPaymentsAdmin,
          name: 'Stripe Connect Payments',
          meta: { requiresAuth: 'cache' }
        },
        {
          path: '/payment/stripe_connect_payments/:txnid',
          component: EcommerceUI.StripeConnectPaymentsForm,
          name: 'Stripe Connect Payments',
          meta: { requiresAuth: 'cache' }
        }
      ])
    }

    // Square Payments
    if (app.registry.getFeature('square-payments') && (process.env.SERVER_BUILD !== 'ssr')) {
      app.addPlugin(SquarePayments, {
        callback: ({ store }) => {
          store.dispatch('ecommerce/onInit', ({ store, config }) => {
            try {
              if (Object.prototype.hasOwnProperty.call(config, 'square_payments')) {
                store.commit('square/SET_MODE', config.square_payments.testmode ? 'development' : 'production')
                store.commit('square/SET_ENDPOINT', store.getters.getServiceEndpoint('payments'))
                store.commit('ecommerce/REGISTER_PAYMENT_METHOD_ACTIVE', { method: 'square_payments', handler: store.getters['square/active'] })

                // We add this promise to the list of promisses required for Payment method to be used so that we can wait if required for them to complete.
                const p = store.dispatch('square/getIsConnected')
                  .finally(_ => {
                    store.commit('ecommerce/PAYMENT_METHOD_PROMISES', { square_payments: null })
                  })
                store.commit('ecommerce/PAYMENT_METHOD_PROMISES', { square_payments: p })
              }
              else {
                applogger.error('Disabling square payments as it is not enabled in the backend.')
                store.commit('ecommerce/REGISTER_PAYMENT_METHOD_ACTIVE', { method: 'square_payments', handler: false })
              }
            }
            catch (err) {
              applogger.error(`Disabling square payments due to configuration error: ${err.message}`)
            }
          })
        }
      })
      app.addRoutes([
        {
          path: '/admin/ecommerce/square',
          component: EcommerceUI.SquarePaymentsAdmin,
          name: 'Square Payments',
          meta: { requiresAuth: 'cache' }
        },
        {
          path: '/payment/square_payments/:txnid',
          component: EcommerceUI.SquarePaymentsForm,
          name: 'Square Payments',
          meta: { requiresAuth: 'cache' }
        }
      ])
    }

    // products content-list
    ContentListRegistry.register('products', {
      label: 'Products',
      options: 'basic',
      sorts: [
        {
          key: 'cheapest',
          label: 'Cheapest first'
        },
        {
          key: 'expensive',
          label: 'Most expensive first'
        }
      ]
    })
    app.addComponent('content-creator-content-list-products', () => import(/* webpackChunkName: 'content-lists' */ '../components/website/content-lists/content-creator-content/0001/Type'))

    if (app.registry.getFeature('wine-products')) {
      app.addPlugin(require('dev/vuejs-wine-product').default)

      // This is the wrapper around the Ecommerce Product catalogue for the Wine Product Catalogue
      const WineCataloguePage = () => import(/* webpackChunkName: 'wine-products' */ '../components/website/wine-products/0001/wine-catalogue-page')
      const WineProductPage = () => import(/* webpackChunkName: 'wine-products' */ '../components/website/wine-products/0001/wine-product-page')
      const WineProductPrice = () => import(/* webpackChunkName: 'wine-products' */ '../components/website/wine-products/0001/ecommerce-product-price')

      const WineCatalogueAsyncLoader = require('../components/website/wine-products/0001/winecatalog-preload-helper')

      // So that there is time to load other things linke images we slightly delay the prefetch of the wine catalogue
      // if (process.env.SERVER_BUILD !== 'ssr') {
      app.addPreloadItem(({ store }) => WineCatalogueAsyncLoader.default(store))
      // blobPreloadIDs.push('catalog-list-banner')
      // }

      app.addComponent('wine-catalogue-page', WineCataloguePage)
      app.addComponent('page-content-type-wine_product', WineProductPage)
      app.addComponent('ecommerce-product-price', WineProductPrice)

      // faqs
      app.addComponent('page-layout-wine-faqs-list', () => import(/* webpackChunkName: 'faq' */ '../components/website/content-lists/faq/0001/page-layout-wine-faqs-list'))
      app.addComponent('page-content-type-wine_product_faq', () => import(/* webpackChunkName: 'faq' */ '../components/website/content-pages/faq/0001/page-content-type-wine_product_faq'))

      app.addRoutes([
        // {
        //   path: '/wines',
        //   component: WineCataloguePage,
        //   name: 'Wine Shop',
        //   meta: {
        //     requiresAuth: 'cache'
        //   }
        // },
        // {
        //   path: '/wine/:name',
        //   component: WineProductPage,
        //   name: 'Wine Product',
        //   meta: {
        //     requiresAuth: 'cache',
        //     ContentItemCheck: true
        //   }
        // },
        {
          path: '/winefaqs',
          component: 'page-layout-wine-faqs-list',
          name: 'Wine Product Frequently Asked Questions',
          meta: {
            requiresAuth: 'allow',
            ContentItemCheck: true
          }
        }
      ])

      // wines content-list
      ContentListRegistry.register('wines', {
        label: 'Wine Products',
        options: 'wines',
        layouts: {
          '0002': {
            key: '0002',
            label: 'Plain (No Background)'
          },
          '0003': {
            key: '0003',
            label: 'Card (Solid Background with padding)'
          },
          '0004': {
            key: '0004',
            label: 'Plain inc Pack Pricing (No Background)'
          },
          '0005': {
            key: '0005',
            label: 'Card inc Pack Pricing (Solid Background with padding)'
          }
        }
      })

      app.addComponent('content-creator-content-list-wines', () => import(/* webpackChunkName: 'content-lists' */ '../components/website/content-lists/content-creator-content/0001/Type'))
    }
  }
}
